import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCreateCategoryGroup } from '../../api/categories';
import CommonModalLayout from '../Layouts/CommonModalLayout';
import { buttonStyles, inputStyles } from '../../styles/commonStyles';
import ErrorMessage from '../Common/ErrorMessage';

const AddCategoryGroupModal = ({ isOpen, onClose, onSuccess }) => {
    const { t } = useTranslation();
    const [groupName, setGroupName] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const createCategoryGroupMutation = useCreateCategoryGroup();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!groupName.trim()) {
            setError('Название группы не может быть пустым');
            return;
        }

        setIsLoading(true);
        setError('');

        try {
            await createCategoryGroupMutation.mutateAsync({
                name: groupName.trim(),
                user_id: null // Будет взят из хука
            });
            
            setGroupName('');
            onSuccess?.();
            onClose();
        } catch (error) {
            console.error('Ошибка создания группы:', error);
            setError(error.message || 'Ошибка создания группы');
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setGroupName('');
        setError('');
        onClose();
    };

    return (
        <>
            {/* Кастомный оверлей с высоким z-index */}
            {isOpen && (
                <div 
                    className="fixed bg-black/60 dark:bg-black/60 backdrop-blur-sm z-[10005] border-0 border-none outline-none"
                    style={{ 
                        border: 'none', 
                        outline: 'none',
                        top: '-1px',
                        right: '-1px', 
                        bottom: '-1px',
                        left: '-1px'
                    }}
                    onClick={() => {}} // Не закрываем по клику на оверлей
                />
            )}
            <CommonModalLayout
                isOpen={isOpen}
                onClose={handleClose}
                title="Новая группа"
                customStyles="fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 w-[90vw] max-w-md z-[10006] border border-gray-300 dark:border-gray-700"
                closeOnOverlayClick={false}
                hideOverlay={true}
            >
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <input
                        id="groupName"
                        type="text"
                        value={groupName}
                        onChange={(e) => setGroupName(e.target.value)}
                        className={inputStyles}
                        placeholder="Введите название группы..."
                        autoFocus
                        maxLength={100}
                    />
                </div>

                <ErrorMessage message={error} />

                <div className="flex justify-end space-x-2 pt-4">
                    <button
                        type="button"
                        onClick={handleClose}
                        className={buttonStyles}
                        disabled={isLoading}
                    >
                        Отмена
                    </button>
                    <button
                        type="submit"
                        className={buttonStyles}
                        disabled={isLoading || !groupName.trim()}
                    >
                        {isLoading ? 'Создание...' : 'Создать группу'}
                    </button>
                </div>
            </form>
            </CommonModalLayout>
        </>
    );
};

export default AddCategoryGroupModal;
